var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVineDesktopFollow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 19,
  viewBox: "0 0 27 19",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M17.017 11.8c2.877 0 9.005 1.314 9.54 4.806-.091.012-.442 1.12-.988 1.278-1.648.476-5.068.192-8.45.191-3.395 0-6.645.228-8.237-.202-.573-.155-.93-1.265-1.003-1.28.543-3.486 6.262-4.793 9.138-4.793M5.047 7.263c-.044.27.142.447.407.406 0 0 3.263-.669 2.963.831.3 1.5-3.45.75-3.45.75s.75 3.75-.75 3.45c-1.5.3-.75-3.45-.75-3.45s-3.75.75-3.45-.75c-.3-1.5 3.45-.75 3.45-.75s-.75-3.75.75-3.45c1.5-.3.83 2.963.83 2.963M16.718 0c1.933 0 3.5 1.639 3.5 4.4s-1.567 5.6-3.5 5.6-3.5-2.839-3.5-5.6 1.567-4.4 3.5-4.4"
})));
export default SvgVineDesktopFollow;